import { Button, Dialog, DialogActions, DialogTitle, Typography, useTheme } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import Iconify from 'src/components/Iconify';
import { ListItemIconStyle, ListItemStyle } from 'src/components/nav-section/vertical/style';
import useToken from 'src/hooks/useToken';
import { PATH_AUTH } from 'src/routes/paths';
import useAdminInfoStore from 'src/store/admin';

const NavbarLogoutItem = ({ isCollapse }) => {
  const uToken = useToken();
  const navigate = useNavigate();
  const { setProfileDetails, setAdminInfo } = useAdminInfoStore();
  const [isOpen, setIsOpen] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();

  const handleLogout = () => {
    localStorage.clear();
    setAdminInfo(null);
    setProfileDetails(null);
    uToken.removeToken();
    navigate(PATH_AUTH.login);
    enqueueSnackbar('از حساب کاربری خود خارج شدید');
  };

  return (
    <>
      <ListItemStyle LinkComponent={'button'} sx={{ color: theme.palette.error.main }} onClick={() => setIsOpen(true)}>
        <ListItemIconStyle>
          <Iconify icon={'heroicons-outline:logout'} />
        </ListItemIconStyle>
        <Typography sx={{ width: isCollapse ? '0px' : 'auto', opacity: isCollapse ? '0' : '1', whiteSpace: 'nowrap', fontSize: '14px' }}>
          خروج از حساب کاربری
        </Typography>
      </ListItemStyle>

      <Dialog open={isOpen} fullWidth maxWidth="xs" onClose={() => setIsOpen(false)}>
        <DialogTitle sx={{ textAlign: 'center' }} fontSize={10}>
          آیا میخواهید از حساب کاربری خود خارج شوید؟
        </DialogTitle>
        <DialogActions sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
          <Button color="error" variant="contained" onClick={handleLogout}>
            بله
          </Button>

          <Button variant="outlined" color="inherit" onClick={() => setIsOpen(false)}>
            خیر
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NavbarLogoutItem;
